import { SEEN_SEND_LIMIT_NOTIFICATION_TABLE_KEY } from '@mm/constants/message-send-limits';
import { ADS_ANALYTICS_QUERY_INFO } from '@mm/constants/ctm-analytics';

export type LocalStorageState = {
  '16'?: string;
  [ADS_ANALYTICS_QUERY_INFO]?: string;
  requestDemoSnoozeDate?: string;
  prevLocationPathName?: string;
  promoCode?: string;
  sendMessageNotificationLookup?: string;
  [SEEN_SEND_LIMIT_NOTIFICATION_TABLE_KEY]?: string;
  client_uuid: string;
  variableChatWidgetActive: string;
  variableChatWidgetClosedAt: string;
  variableChatGreetingsClosed: string;
};

const supportsLocalStorage = () => {
  try {
    localStorage.setItem('test', '');
    localStorage.removeItem('test');
    return true;
  } catch (exception) {
    return false;
  }
};

// Fallback for browsers in private mode so we don't have to if (localStorage) everywhere
class LocalStorageFallbackService {
  data = {};

  setItem(key, value) {
    this.data[key] = value;
  }

  getItem(key) {
    if (this[key]) {
      return this[key];
    }

    return null;
  }

  removeItem(key) {
    delete this[key];
  }

  clear() {
    this.data = {};
  }
}

const initLocalStorageService = () => {
  const storageProvider = supportsLocalStorage()
    ? localStorage
    : new LocalStorageFallbackService();

  const setItem = (key: keyof LocalStorageState | string, value: string) => {
    storageProvider.setItem(key, value);
  };

  const removeItem = (key: keyof LocalStorageState | string) => {
    storageProvider.removeItem(key);
  };

  const getItem = (key: keyof LocalStorageState | string) => {
    return storageProvider.getItem(key);
  };

  return {
    setItem,
    getItem,
    removeItem,
  };
};

const LocalStorageService = initLocalStorageService();

export default LocalStorageService;
